import { IPublicCreditCard } from '@wix/cashier-core/dist/src/services/CreditCard/types';
import React from 'react';
import { Text } from 'wix-ui-tpa/Text';
import { DH } from '../../../../utils/DataHook';
import { t } from '../../../../utils/i18n';
import { CreditCardNetworkIcon } from '../../../PaymentMethodIcon/icons/CreditCardNetworkIcon';
import {
  formatMonth,
  formatYear,
} from '../../../SavedCreditCardsList/SavedCreditCardItem/helpers';
import { classes } from './styles.st.css';

export const SavedCreditCardItem = (props: IPublicCreditCard) => {
  return (
    <div className={classes.savedCardItemContainer}>
      <div>
        <div>
          <Text className={classes.cardDetails}>
            <span>{t(`network.${props.network}`)}</span>
            <span>
              (
              <span data-hook={DH.SavedCard.Item.LastDigits}>
                {props.lastFourDigits}
              </span>
              )
            </span>
          </Text>
        </div>
        {props.expired ? (
          <div>
            <Text
              data-hook={DH.SavedCard.Item.ExpiredMessage}
              className={classes.expired}
            >
              {t('savedCreditCards.expired')}
            </Text>
          </div>
        ) : (
          <Text>
            <span>{t('savedCreditCards.expireDate')}</span>
            <span data-hook={DH.SavedCard.Item.ExpireDate}>
              <span>{formatMonth(props.expiration.month)}</span>
              <span>/</span>
              <span>{formatYear(props.expiration.year)}</span>
            </span>
          </Text>
        )}
      </div>

      <div className={classes.icon}>
        <CreditCardNetworkIcon cardNetwork={props.network} />
      </div>
    </div>
  );
};
SavedCreditCardItem.displayName = 'SavedCreditCardItem';
